













































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";

import numeral from "numeral";
import uniq from "lodash/uniq";

import { STORE_KEY, store } from "./_store";

import ProductCombobox from "@/components/Controls/ProductCombobox.vue";
import ProductContainerCombobox from "@/components/Controls/ProductContainerCombobox.vue";
import Attachments from "@/components/Controls/Attachments.vue";
import ShiftCustomPlanForm from "@/modules/ShiftDetails/ShiftCustomPlan/ShiftCustomPlanForm/ShiftCustomPlanForm.vue";
import ShiftAddWashForm from "@/modules/ShiftDetails/ShiftAddWashForm/ShiftAddWashForm.vue";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      "loading",
      "loaded",
      "fatalError",

      "relatedPlansList",
      "prevPlansList"

      // 'document', 'meta'
    ]),
    ...mapState("ubic", ["token", "actor"]),
    ...mapGetters(STORE_KEY, ["remainsById", "totals"])
  },
  methods: {
    ...mapActions(STORE_KEY, ["addItem", "removeItem"])
  },
  components: {
    ProductCombobox,
    ProductContainerCombobox,
    Attachments
  }
})
export default class ShiftCustomPlan extends Vue {
  @Prop() documentId!: string;
  @Prop() document!: string;
  @Prop() realBeginTime!: string;
  @Prop() realEndTime!: string;
  @Prop() relTimeOfDay!: string;

  relatedPlansList!: any[];
  actor!: any[];

  opened: any[] = [];
  public dropFiles = [];

  FILES_HOST = process.env.VUE_APP_UBIC_SERVER_ADDRESS;

  // items: any[] = [];

  allowDelete() {
    const exists_roles: any[] = [
      "admin",
      "manufacture_head"
    ].filter((role: string) => (this.actor as any).roles.includes(role));
    return exists_roles.length > 0;
  }

  formatNumber(value: any) {
    return numeral(value).format("0,0");
  }

  onDetailToggle(row: any, to: string) {
    if (to == "open") {
      this.opened = uniq([...this.opened, row.id]);
    } else {
      this.opened = uniq(this.opened.filter($row => $row.id != row.id));
    }
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    } else {
      this.$store.dispatch(`${STORE_KEY}/reset`);
    }
  }

  @Watch("realBeginTime")
  onrealBeginTime() {
    console.log("bt => ", this.realBeginTime);
    this.loadData();
  }

  public mounted() {
    this.loadData();
  }

  public loadData() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
      documentId: this.documentId,
      realEndTime: this.realEndTime,
      relTimeOfDay: this.relTimeOfDay
    });
  }

  openDocument(row: any) {
    const letter = this.relTimeOfDay ? this.relTimeOfDay[0] : "";
    this.$buefy.modal.open({
      component: ShiftCustomPlanForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        documentId: this.documentId,
        initParams: {
          shift_id: this.documentId,
          number: this.relatedPlansList.length + 1 + letter,
          ignore_done_delay: false
        }
      },
      events: {
        "form-close": () => {
          this.loadData();
        }
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: "document-form short-form",
      parent: this
    });
  }

  openEquipmentForm(equipments: any[]) {
    const numberStart = this.relatedPlansList.length
      ? Math.max.apply(
          null,
          this.relatedPlansList.map((i: any) => parseInt(i.number))
        ) + 1
      : 1;
    this.$buefy.modal.open({
      component: ShiftAddWashForm,
      props: {
        equipments: equipments,
        typeLine: "custom",
        initParams: {
          shift_id: this.documentId,
          numberStart: numberStart
        }
      },
      events: {
        "form-close": () => {
          this.loadData();
        },
        close: () => {
          this.loadData();
        }
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: "document-form short-form",
      parent: this
    });
  }

  deleteDocument(row: any) {
    this.$buefy.dialog.confirm({
      message: `Удалить партию ${row.number}?`,
      confirmText: "Удалить",
      cancelText: "Отмена",
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store
          .dispatch(`${STORE_KEY}/deleteDocument`, row)
          .then(result => {
            this.$buefy.snackbar.open(`Запись удалена`);
          })
          .catch(() => {
            this.$buefy.snackbar.open({
              type: "is-warning",
              message: `При сохранении возникли проблемы. Попробуйте позже.`
            });
          });
      }
    });
  }

  restoreDocument(row: any) {
    this.$buefy.dialog.confirm({
      message: `Восстановить партию ${row.number}?`,
      confirmText: "Восстановить",
      cancelText: "Отмена",
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store
          .dispatch(`${STORE_KEY}/restoreDocument`, row)
          .then(result => {
            this.$buefy.snackbar.open(`Запись удалена`);
          })
          .catch(() => {
            this.$buefy.snackbar.open({
              type: "is-warning",
              message: `При сохранении возникли проблемы. Попробуйте позже.`
            });
          });
      }
    });
  }

  changeFormValue(index: number, field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      index,
      field,
      newValue: value
    });
  }

  sortByNumber(a: any, b: any, isArc: boolean) {
    console.log(a, b, isArc);
    const keyA = parseFloat(a.number);
    const keyB = parseFloat(b.number);
    const result = keyA > keyB ? 1 : keyA < keyB ? -1 : 0;
    return result * (isArc ? 1 : -1);
  }

  uploadFile(files: File[], index: any) {
    for (const file of files) {
      const formData = new FormData();

      formData.append("file", file);

      // @ts-ignore
      this.$http
        .post(`/api/v1/files`, formData, {
          // emulateJSON: true,
          // headers: {
          //   'Content-Disposition': `form-data; name="photo"; filename="${file.name}"`
          // }
        })
        .then((response: any) => {
          this.$store.dispatch(`${STORE_KEY}/addAttachments`, {
            newValue: response.data.file,
            index
          });
        });
    }
    this.dropFiles = [];
  }
  addAttachments(file: any, data: any) {
    data.row.attachments.push(file);
    this.saveFormData(data.row);
  }

  removeFile(idx: number, data: any) {
    console.log(data, idx);
    data.row.attachments.splice(idx, 1);
    this.saveFormData(data.row);
  }

  saveFormData(item: any) {
    item.editable = false;
    // this.$v.form.$touch()

    // if(!this.$v.form.$error) {
    this.$store
      .dispatch(`${STORE_KEY}/saveForm`, { realEndTime: this.realEndTime })
      .then(result => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        // this.$v.form.$reset();
        console.log("123123");
        // this.$store.dispatch(`${PARENT_STORE_KEY}/updateReserves`, {
        //   zone: this.zone,
        //   reserves: this.reserves
        // });

        // this.$emit('on-need-data-reload', result.document.id)
      })
      .catch(e => {
        console.log(e);
        this.$buefy.snackbar.open({
          type: "is-warning",
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        });
      });
    // }
  }

  setExctartTime(row: any, extract_time: any) {
    row.finalized = false;
    this.$store.dispatch(`${STORE_KEY}/setExctartTime`, {
      documentId: this.documentId,
      row,
      extract_time
    });
  }
}
